import { QuantumMetricsContext as m } from "@fcamna/shared-component-foundations";
import { useContext as n } from "react";
const s = ({ label: t }) => {
  const { productName: e, repositoryLink: o, themeName: r, mode: a } = n(m);
  return {
    "data-qm": "track-ucl",
    "data-qm-label": `UCL-${t}`,
    "data-qm-description": `UCL-${JSON.stringify({ productName: e, repositoryLink: o, themeName: r, mode: a })}`
  };
};
export {
  s as u
};
